var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-condition-form-drop-area",class:{ 'filter-condition-form-drop-area--hover': _vm.isDragOver },style:({ height: _vm.height }),attrs:{"data-cy":_vm.type === 'addNode'
      ? 'condition-form-drop-area-add-node'
      : 'condition-form-drop-area-or-node'},on:{"dragover":function($event){$event.preventDefault();},"drop":_vm.onDrop,"dragenter":_vm.onDragEnter,"dragleave":_vm.onDragLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }